// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var dataRouter = {
  path: '/data',
  component: Layout,
  redirect: '/data/dashboard',
  name: 'data',
  alwaysShow: true,
  meta: {
    title: '统计',
    icon: 'clipboard'
  },
  children: [{
    path: 'overview',
    name: 'dataOverview',
    meta: {
      title: '数据总览'
    },
    component: function component() {
      return import('@/views/data/overview/index');
    }
  }, {
    path: 'dashboard',
    name: "dashboard",
    meta: {
      title: '控制台'
    },
    component: function component() {
      return import('@/views/data/dashboard/index');
    }
  }, {
    path: 'purchase',
    name: "purchase",
    meta: {
      title: '控制台-采购'
    },
    component: function component() {
      return import('@/views/data/purchase/index');
    }
  }, {
    path: 'goods',
    name: "goods",
    meta: {
      title: '商品统计'
    },
    component: function component() {
      return import('@/views/data/goods/index');
    }
  }, {
    path: 'user',
    name: "user",
    meta: {
      title: '用户统计'
    },
    component: function component() {
      return import('@/views/data/user/index');
    }
  }, {
    path: 'transaction',
    name: "transaction",
    meta: {
      title: '交易统计'
    },
    component: function component() {
      return import('@/views/data/transaction/index');
    }
  }]
};
export default dataRouter;